import { isAxiosError, type AxiosError } from 'axios';
import { useCallback } from 'react';
import { useAppDispatch } from '@shared/hooks';
import { openNotifyModal } from '@src/library/redux/modal';

const openTechnicalSupportModal = (code: number) =>
  openNotifyModal({
    title: 'Оповещение',
    text: `Возникли технические неполадки (${code})`,
    confirmText: 'Ок',
  });

export const openCannotChangeCurrentResourceNotify_405 = () => {
  return openNotifyModal({
    title: 'Оповещение',
    text: `Платформа является демонстрационной, изменения невозможны.`,
    confirmText: 'Ок',
  });
};

export const openServerErrorNotify_500 = () => {
  return openTechnicalSupportModal(500);
};

export const openClientErrorNotify_400 = () => {
  return openTechnicalSupportModal(400);
};

const logUnknownError = (error: unknown) => {
  console.log('Unknown error:', error);
};

const axiosErrorsHandler = (dispatch: AppDispatch, error: AxiosError) => {
  const statusCode = error?.response?.status;
  switch (statusCode) {
    case 405: {
      dispatch(openCannotChangeCurrentResourceNotify_405());
      break;
    }
    default: {
      logUnknownError(error);
    }
  }
};

export const useErrorHandler = () => {
  const dispatch = useAppDispatch();

  const handleError = useCallback(
    (error: unknown) => {
      if (isAxiosError(error)) {
        axiosErrorsHandler(dispatch, error);
      } else {
        logUnknownError(error);
      }
    },
    [dispatch]
  );

  return {
    handleError,
  };
};
